import React, { useEffect, useState } from "react";
import { db, storage } from "../../../../../firebase";
import { 
  doc, 
  getDoc, 
  updateDoc, 
  collection, 
  getDocs,
  addDoc,
  deleteDoc,
  query,
  where 
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

export default function CompanyProjectsDetails() {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    projectInfo: {},
    locationInfo: {},
    floorPlans: {},
    buildingFeatures: {},
    outsideFeatures: {},
    environmentFeatures: {}
  });
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [newBrochure, setNewBrochure] = useState(null);
  const [unitImages, setUnitImages] = useState({});
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [unitsToDelete, setUnitsToDelete] = useState([]);

  // Feature lists (AddProjects'ten alındı - özel karakterler düzeltildi)
  const buildingFeaturesList = [
    'Merkezi ısıtma sistemi', 'Doğalgaz altyapısı', 'Yerden ısıtma sistemi', 'Isı yalıtımı',
    'Ses yalıtımı', 'Klima altyapısı', 'Merkezi klima (VRF sistemi)', 'Kombi sistemi',
    'Asansör', 'Yük asansörü', 'Akıllı ev sistemi', 'Güvenlik sistemi', 'Yangın alarmı',
    'Yangın merdiveni', 'Sprinkler yangın söndürme sistemi', 'Jeneratör', 'UPS sistemi',
    'Fiber internet altyapısı', 'Uydu TV altyapısı', 'Görüntülü diafon', 'Güneş enerjisi sistemi',
    'Engelli erişimi', 'Radye temel', 'Tünel kalıp sistemi', 'Sismik izolatörlü yapı',
    'Özel güvenlik kapısı', 'Temizlik hizmetleri', 'Ortak depo kiler alanı', 'Kiler (daireye özel)',
    'Balkon', 'Akıllı sayaçlar', 'Site yönetimi hizmeti'
  ];

  const outsideFeaturesList = [
    'Ortak kullanım bahçesi', 'Çocuk oyun alanı', 'Spor alanı', 'Basketbol sahası',
    'Voleybol sahası', 'Tenis kortu', 'Fitness alanı', 'Yürüyüş parkuru', 'Bisiklet park yeri',
    'Kamelya oturma alanı', 'Açık yüzme havuzu', 'Kapalı yüzme havuzu', 'Sauna', 'Hamam',
    'Buhar odası', 'Masaj odası', 'Açık otopark', 'Kapalı otopark', 'Misafir otoparkı',
    'Otoparkta elektrikli araç şarj ünitesi', '7 24 güvenlik', 'Güvenlik kamerası sistemi (CCTV)',
    'Kartlı giriş sistemi', 'Plaka tanıma sistemi', 'Turnike giriş sistemi', 'Acil durum çıkışları',
    'Site içi ATM', 'Site içi market', 'Evcil hayvan alanı', 'Evcil hayvan parkuru'
  ];

  const environmentFeaturesList = [
    'Market', 'Alışveriş merkezi (AVM)', 'İlkokul', 'Lise', 'Anaokulu kreş', 'Üniversite',
    'Park alanı', 'Oyun parkı', 'Metro tramvay durağı', 'Otobüs durağı', 'Minibüs güzergahı',
    'Otogar', 'tren istasyonu', 'havaalanı', 'Hastane', 'Sağlık ocağı', 'Aile sağlık merkezi',
    'Eczane', 'Camii', 'Kilise', 'İlçe Belediye Binası', 'İl Belediye Binası', 'Polis karakolu',
    'Postane Şubeleri', 'Sosyal tesis kültür merkezi', 'Spor salonları', 'Açık hava spor alanları',
    'Kafeterya restoran kafe', 'Sinema tiyatro', 'Sahil deniz manzarası', 'Orman doğa manzarası',
    'Göl nehir manzarası', 'Sessiz ve sakin çevre', 'Gelişen bölge yatırım potansiyeli',
    'Ana caddeye yakınlık', 'Sanayiye yakınlık', 'iş merkezlerine yakınlık', 'Kütüphane', 'Halk eğitim merkezi'
  ];

  const apartmentTypes = [
    "1+0", "1+1", "2+1", "3+1", "4+1", "4+2", "5+1", "5+2",
    "6+1", "6+2", "7+1", "7+2", "8+1", "8+2", "9+1", "9+2"
  ];

  // Özel karakterleri düzeltmek için mapping fonksiyonu
  const cleanFeatureName = (feature) => {
    return feature.replace(/\//g, ' ').replace(/\(/g, '').replace(/\)/g, '');
  };

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const projectId = localStorage.getItem("selectedProjectId");
        if (!projectId) {
          setError("Proje ID bulunamadı.");
          setLoading(false);
          return;
        }

        // Fetch cities for dropdown
        const citiesSnapshot = await getDocs(collection(db, 'cities'));
        const cityList = citiesSnapshot.docs.map(doc => doc.id);
        setCities(cityList.sort());

        // Fetch main project data
        const projectRef = doc(db, "projects", projectId);
        const projectSnap = await getDoc(projectRef);

        if (!projectSnap.exists()) {
          setError("Proje bulunamadı.");
          setLoading(false);
          return;
        }

        const projectData = { id: projectSnap.id, ...projectSnap.data() };
        setProject(projectData);

        // Fetch additional data
        await fetchAdditionalData(projectId, projectData);
        
      } catch (err) {
        console.error("Proje detayları alınamadı:", err);
        setError("Proje detayları yüklenirken hata oluştu.");
      } finally {
        setLoading(false);
      }
    };

    const fetchAdditionalData = async (projectId, mainProjectData) => {
      try {
        // Fetch location details
        const locationDetailsRef = collection(db, `projects/${projectId}/location_details`);
        const locationSnapshot = await getDocs(locationDetailsRef);
        
        let locationData = {};
        locationSnapshot.forEach(doc => {
          locationData[doc.id] = doc.data();
        });

        // Fetch apartment types
        const apartmentTypesRef = collection(db, `projects/${projectId}/apartment_types`);
        const apartmentSnapshot = await getDocs(apartmentTypesRef);
        const apartmentTypes = [];
        apartmentSnapshot.forEach(doc => {
          apartmentTypes.push({ type: doc.id, ...doc.data() });
        });

        // Fetch features (özel karakterler temizlenmiş olarak)
        const buildingFeatures = await fetchFeatures(projectId, 'building_features');
        const outsideFeatures = await fetchFeatures(projectId, 'outside_features');
        const environmentFeatures = await fetchFeatures(projectId, 'environment_features');

        // Set form data structure similar to AddProjects
        setFormData({
          projectInfo: {
            projectName: mainProjectData.project_name || "",
            price: mainProjectData.price || "",
            city: mainProjectData.city || "",
            district: mainProjectData.district || "",
            deliveryDate: mainProjectData.delivery_date || "",
            totalUnits: mainProjectData.num_houses || "",
            area: mainProjectData.area || "",
            projectStatus: mainProjectData.project_status || "",
            description: mainProjectData.project_description || "",
            archDescription: mainProjectData.arch_description || "",
            images: mainProjectData.image_urls || [],
            brochureUrl: mainProjectData.pdf_brochure || ""
          },
          locationInfo: {
            mapsUrl: locationData.locations?.google_maps_link || "",
            address: locationData.locations?.address || "",
            surroundings: locationData.nearby_locations || {},
            institutions: locationData.nearby_institutions || {}
          },
          floorPlans: {
            description: mainProjectData.arch_description || "",
            units: apartmentTypes
          },
          buildingFeatures: buildingFeatures,
          outsideFeatures: outsideFeatures,
          environmentFeatures: environmentFeatures
        });

        // Fetch districts if city is available
        if (mainProjectData.city) {
          fetchDistricts(mainProjectData.city);
        }

      } catch (error) {
        console.error("Ek veriler alınamadı:", error);
      }
    };

    const fetchFeatures = async (projectId, featureType) => {
      try {
        const featuresRef = collection(db, `projects/${projectId}/${featureType}`);
        const featuresSnapshot = await getDocs(featuresRef);
        if (!featuresSnapshot.empty) {
          const featuresData = featuresSnapshot.docs[0].data();
          // Özel karakterleri temizle
          const cleanedFeatures = {};
          Object.keys(featuresData).forEach(key => {
            const cleanedKey = cleanFeatureName(key);
            cleanedFeatures[cleanedKey] = featuresData[key];
          });
          return cleanedFeatures;
        }
        return {};
      } catch (error) {
        console.error(`${featureType} alınamadı:`, error);
        return {};
      }
    };

    const fetchDistricts = async (cityId) => {
      try {
        const districtsRef = collection(db, 'cities', cityId, 'districts');
        const districtSnapshot = await getDocs(districtsRef);
        const districtList = districtSnapshot.docs.map(doc => doc.id);
        setDistricts(districtList.sort());
      } catch (error) {
        console.error('İlçeleri çekerken hata:', error);
      }
    };

    fetchProjectData();
  }, []);

  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleNestedInputChange = (section, subSection, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [subSection]: {
          ...prev[section][subSection],
          [field]: value
        }
      }
    }));
  };

  const handleFeatureChange = (featureType, feature, value) => {
    setFormData(prev => ({
      ...prev,
      [featureType]: {
        ...prev[featureType],
        [feature]: value
      }
    }));
  };

  const handleUnitChange = (index, field, value) => {
    const updatedUnits = [...formData.floorPlans.units];
    updatedUnits[index] = { ...updatedUnits[index], [field]: value };
    
    setFormData(prev => ({
      ...prev,
      floorPlans: {
        ...prev.floorPlans,
        units: updatedUnits
      }
    }));
  };

  const addNewUnit = () => {
    const newUnit = {
      type: "",
      net_area: "",
      gross_area: "",
      facade: "",
      balcony: false,
      image_url: ""
    };
    
    setFormData(prev => ({
      ...prev,
      floorPlans: {
        ...prev.floorPlans,
        units: [...prev.floorPlans.units, newUnit]
      }
    }));
  };

  const removeUnit = (index) => {
    if (!window.confirm("Bu daire tipini silmek istediğinizden emin misiniz?")) return;

    const unitToDelete = formData.floorPlans.units[index];
    
    // Eğer unit'in bir type'ı varsa (yani Firebase'de kayıtlıysa), silinecekler listesine ekle
    if (unitToDelete.type) {
      setUnitsToDelete(prev => [...prev, unitToDelete.type]);
    }

    // Eğer unit'in bir görseli varsa, onu da silinecekler listesine ekle
    if (unitToDelete.image_url) {
      setImagesToDelete(prev => [...prev, unitToDelete.image_url]);
    }

    // State'den sil
    const updatedUnits = formData.floorPlans.units.filter((_, i) => i !== index);
    setFormData(prev => ({
      ...prev,
      floorPlans: {
        ...prev.floorPlans,
        units: updatedUnits
      }
    }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setNewImages(prev => [...prev, ...files]);
  };

  const handleBrochureChange = (e) => {
    if (e.target.files[0]) {
      setNewBrochure(e.target.files[0]);
    }
  };

  const handleUnitImageChange = (index, file) => {
    setUnitImages(prev => ({
      ...prev,
      [index]: file
    }));
  };

  const removeExistingImage = (imageUrl, index) => {
    if (!window.confirm("Bu görseli silmek istediğinizden emin misiniz?")) return;

    // Görseli silinecekler listesine ekle
    setImagesToDelete(prev => [...prev, imageUrl]);
    
    // State'den sil
    const updatedImages = formData.projectInfo.images.filter((_, i) => i !== index);
    handleInputChange('projectInfo', 'images', updatedImages);
  };

  const removeNewImage = (index) => {
    const updatedNewImages = newImages.filter((_, i) => i !== index);
    setNewImages(updatedNewImages);
  };

  const uploadNewImages = async () => {
    if (!newImages.length) return formData.projectInfo.images;

    const uploadedUrls = [];
    
    for (let i = 0; i < newImages.length; i++) {
      const image = newImages[i];
      const fileExtension = image.name.split('.').pop().toLowerCase();
      if (['png', 'jpg', 'jpeg'].includes(fileExtension)) {
        // AddProjects'teki gibi sıralı isimlendirme: 0.jpg, 1.jpg, 2.jpg...
        const nextIndex = formData.projectInfo.images.length + i;
        const imageRef = ref(storage, `projects/${project.id}/image/${nextIndex}.jpg`);
        await uploadBytes(imageRef, image);
        const url = await getDownloadURL(imageRef);
        uploadedUrls.push(url);
      }
    }

    return [...formData.projectInfo.images, ...uploadedUrls];
  };

  const uploadNewBrochure = async () => {
    if (!newBrochure) return formData.projectInfo.brochureUrl;

    const brochureRef = ref(storage, `projects/${project.id}/brochure.pdf`);
    await uploadBytes(brochureRef, newBrochure);
    return await getDownloadURL(brochureRef);
  };

  const uploadUnitImages = async () => {
    const updatedUnits = [...formData.floorPlans.units];
    
    for (let index in unitImages) {
      const unitIndex = parseInt(index);
      const imageFile = unitImages[index];
      
      if (imageFile && updatedUnits[unitIndex].type) {
        const imageRef = ref(storage, `projects/${project.id}/apartment_types/${updatedUnits[unitIndex].type}/plan.jpg`);
        await uploadBytes(imageRef, imageFile);
        const imageUrl = await getDownloadURL(imageRef);
        updatedUnits[unitIndex].image_url = imageUrl;
      }
    }

    return updatedUnits;
  };

  const deleteImagesFromStorage = async () => {
    for (const imageUrl of imagesToDelete) {
      try {
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);
      } catch (error) {
        console.error("Görsel silinirken hata:", error);
      }
    }
  };

  const deleteUnitsFromFirestore = async () => {
    for (const unitType of unitsToDelete) {
      try {
        const unitDocRef = doc(db, `projects/${project.id}/apartment_types/${unitType}`);
        await deleteDoc(unitDocRef);
        
        // Ayrıca unit'in görselini de storage'dan sil
        const unitImageRef = ref(storage, `projects/${project.id}/apartment_types/${unitType}/plan.jpg`);
        try {
          await deleteObject(unitImageRef);
        } catch (error) {
          // Görsel zaten silinmiş olabilir, bu normal
          console.log("Unit görseli zaten silinmiş:", error);
        }
      } catch (error) {
        console.error("Unit silinirken hata:", error);
      }
    }
  };

  const handleSave = async () => {
    if (!project?.id) return;
    
    setSaving(true);
    try {
      const projectId = project.id;

      // Önce silinecek görselleri ve unit'leri storage'dan sil
      await deleteImagesFromStorage();
      await deleteUnitsFromFirestore();

      // Upload new files
      setUploading(true);
      const finalImageUrls = await uploadNewImages();
      const finalBrochureUrl = await uploadNewBrochure();
      const finalUnits = await uploadUnitImages();
      setUploading(false);

      // Update main project document
      const projectRef = doc(db, "projects", projectId);
      await updateDoc(projectRef, {
        project_name: formData.projectInfo.projectName,
        price: formData.projectInfo.price,
        city: formData.projectInfo.city,
        district: formData.projectInfo.district,
        delivery_date: formData.projectInfo.deliveryDate,
        num_houses: parseInt(formData.projectInfo.totalUnits) || 0,
        area: formData.projectInfo.area,
        project_status: parseInt(formData.projectInfo.projectStatus) || 0,
        project_description: formData.projectInfo.description,
        arch_description: formData.floorPlans.description,
        image_urls: finalImageUrls,
        pdf_brochure: finalBrochureUrl
      });

      // Update location details
      await updateLocationDetails(projectId);
      
      // Update apartment types - hem mevcutları güncelle hem de yeni eklenenleri kaydet
      await updateApartmentTypes(projectId, finalUnits);
      
      // Update features (özel karakterler temizlenmiş olarak)
      await updateFeatures(projectId, 'building_features', formData.buildingFeatures);
      await updateFeatures(projectId, 'outside_features', formData.outsideFeatures);
      await updateFeatures(projectId, 'environment_features', formData.environmentFeatures);

      // Reset file states
      setNewImages([]);
      setNewBrochure(null);
      setUnitImages({});
      setImagesToDelete([]);
      setUnitsToDelete([]);

      alert("Proje başarıyla güncellendi!");
      
      // Sayfayı yenile
      window.location.reload();
    } catch (error) {
      console.error("Güncelleme hatası:", error);
      alert("Güncelleme sırasında hata oluştu: " + error.message);
    } finally {
      setSaving(false);
      setUploading(false);
    }
  };

  const updateLocationDetails = async (projectId) => {
    const locationDetailsRef = collection(db, `projects/${projectId}/location_details`);
    
    // Update locations
    const locationsDoc = doc(locationDetailsRef, "locations");
    await updateDoc(locationsDoc, {
      google_maps_link: formData.locationInfo.mapsUrl,
      address: formData.locationInfo.address
    });

    // Update nearby locations
    const nearbyLocationsDoc = doc(locationDetailsRef, "nearby_locations");
    await updateDoc(nearbyLocationsDoc, formData.locationInfo.surroundings);

    // Update nearby institutions
    const nearbyInstitutionsDoc = doc(locationDetailsRef, "nearby_institutions");
    await updateDoc(nearbyInstitutionsDoc, formData.locationInfo.institutions);
  };

  const updateApartmentTypes = async (projectId, units) => {
    const apartmentTypesRef = collection(db, `projects/${projectId}/apartment_types`);
    
    for (const unit of units) {
      if (unit.type) { // Sadece type'ı olan unit'leri kaydet
        const unitDoc = doc(apartmentTypesRef, unit.type);
        await updateDoc(unitDoc, {
          net_area: unit.net_area,
          gross_area: unit.gross_area,
          facade: unit.facade,
          balcony: unit.balcony,
          image_url: unit.image_url || ""
        });
      }
    }
  };

  const updateFeatures = async (projectId, featureType, features) => {
    const featuresRef = collection(db, `projects/${projectId}/${featureType}`);
    const featuresDoc = doc(featuresRef, "features");
    
    // Özel karakterleri temizle
    const cleanedFeatures = {};
    Object.keys(features).forEach(key => {
      const cleanedKey = cleanFeatureName(key);
      cleanedFeatures[cleanedKey] = features[key];
    });
    
    await updateDoc(featuresDoc, cleanedFeatures);
  };

  if (loading) return <p style={{ textAlign: "center" }}>Proje detayları yükleniyor...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;
  if (!project) return null;

  return (
    <div style={styles.mainContainer}>
      <div style={styles.header}>
        <h1 style={styles.mainTitle}>
          {formData.projectInfo.projectName || "Proje Detayları"}
        </h1>
        <p style={styles.subtitle}>Proje bilgilerini görüntüleyin ve düzenleyin</p>
      </div>

      <div style={styles.formContainer}>
        {/* Proje Bilgileri */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>🏢 Proje Bilgileri</h2>
          <div style={styles.grid}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>Proje Adı</label>
              <input
                type="text"
                value={formData.projectInfo.projectName || ""}
                onChange={(e) => handleInputChange('projectInfo', 'projectName', e.target.value)}
                style={styles.input}
              />
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Fiyat</label>
              <input
                type="text"
                value={formData.projectInfo.price || ""}
                onChange={(e) => handleInputChange('projectInfo', 'price', e.target.value)}
                style={styles.input}
              />
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>İl</label>
              <select
                value={formData.projectInfo.city || ""}
                onChange={(e) => handleInputChange('projectInfo', 'city', e.target.value)}
                style={styles.select}
              >
                <option value="">İl seçin</option>
                {cities.map(city => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </select>
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>İlçe</label>
              <select
                value={formData.projectInfo.district || ""}
                onChange={(e) => handleInputChange('projectInfo', 'district', e.target.value)}
                style={styles.select}
              >
                <option value="">İlçe seçin</option>
                {districts.map(district => (
                  <option key={district} value={district}>{district}</option>
                ))}
              </select>
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Teslim Tarihi</label>
              <input
                type="text"
                value={formData.projectInfo.deliveryDate || ""}
                onChange={(e) => handleInputChange('projectInfo', 'deliveryDate', e.target.value)}
                style={styles.input}
              />
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Toplam Konut Sayısı</label>
              <input
                type="number"
                value={formData.projectInfo.totalUnits || ""}
                onChange={(e) => handleInputChange('projectInfo', 'totalUnits', e.target.value)}
                style={styles.input}
              />
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Proje Alanı</label>
              <input
                type="text"
                value={formData.projectInfo.area || ""}
                onChange={(e) => handleInputChange('projectInfo', 'area', e.target.value)}
                style={styles.input}
              />
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>Proje Durumu (0-10)</label>
              <input
                type="number"
                min="0"
                max="10"
                value={formData.projectInfo.projectStatus || ""}
                onChange={(e) => handleInputChange('projectInfo', 'projectStatus', e.target.value)}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Proje Açıklaması</label>
            <textarea
              value={formData.projectInfo.description || ""}
              onChange={(e) => handleInputChange('projectInfo', 'description', e.target.value)}
              style={styles.textarea}
              rows="4"
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Mimari Açıklama</label>
            <textarea
              value={formData.floorPlans.description || ""}
              onChange={(e) => handleInputChange('floorPlans', 'description', e.target.value)}
              style={styles.textarea}
              rows="4"
            />
          </div>
        </div>

        {/* Görsel Yönetimi */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>🖼️ Görsel Yönetimi</h2>
          
          {/* Mevcut Görseller */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Mevcut Proje Görselleri</label>
            <div style={styles.imagesContainer}>
              {formData.projectInfo.images?.map((imageUrl, index) => (
                <div key={index} style={styles.imageItem}>
                  <img src={imageUrl} alt={`Proje görseli ${index + 1}`} style={styles.image} />
                  <button
                    type="button"
                    onClick={() => removeExistingImage(imageUrl, index)}
                    style={styles.deleteImageButton}
                  >
                    🗑️ Sil
                  </button>
                </div>
              ))}
              {(!formData.projectInfo.images || formData.projectInfo.images.length === 0) && (
                <p style={styles.noImagesText}>Henüz görsel eklenmemiş</p>
              )}
            </div>
          </div>

          {/* Yeni Görsel Ekleme */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Yeni Görseller Ekle (.png, .jpg, .jpeg)</label>
            <input
              type="file"
              multiple
              accept=".png,.jpg,.jpeg"
              onChange={handleImageChange}
              style={styles.fileInput}
            />
            {newImages.length > 0 && (
              <div style={styles.newImagesPreview}>
                <p style={styles.newImagesTitle}>Yeni eklenecek görseller ({newImages.length}):</p>
                <div style={styles.newImagesGrid}>
                  {newImages.map((file, index) => (
                    <div key={index} style={styles.newImageItem}>
                      <img 
                        src={URL.createObjectURL(file)} 
                        alt={`Yeni görsel ${index + 1}`} 
                        style={styles.newImage} 
                      />
                      <button 
                        type="button"
                        onClick={() => removeNewImage(index)}
                        style={styles.removeNewImageButton}
                      >
                        ×
                      </button>
                      <span style={styles.fileName}>{file.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Broşür Yönetimi */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Broşür Dosyası</label>
            {formData.projectInfo.brochureUrl && (
              <div style={styles.brochureInfo}>
                <p>Mevcut broşür: 
                  <a href={formData.projectInfo.brochureUrl} target="_blank" rel="noopener noreferrer" style={styles.downloadLink}>
                    📄 Broşürü Görüntüle
                  </a>
                </p>
              </div>
            )}
            <input
              type="file"
              accept=".pdf"
              onChange={handleBrochureChange}
              style={styles.fileInput}
            />
            {newBrochure && (
              <p style={styles.newFileInfo}>Yeni broşür: {newBrochure.name}</p>
            )}
          </div>
        </div>

        {/* Konum Bilgileri */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>📍 Konum Bilgileri</h2>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Google Maps URL</label>
            <input
              type="url"
              value={formData.locationInfo.mapsUrl || ""}
              onChange={(e) => handleInputChange('locationInfo', 'mapsUrl', e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Adres</label>
            <textarea
              value={formData.locationInfo.address || ""}
              onChange={(e) => handleInputChange('locationInfo', 'address', e.target.value)}
              style={styles.textarea}
              rows="3"
            />
          </div>

          {/* Yakın Çevre */}
          <h3 style={styles.subSectionTitle}>Yakın Çevre</h3>
          <div style={styles.grid}>
            {['park', 'mall', 'metro', 'bus'].map(item => (
              <div key={item} style={styles.fieldGroup}>
                <label style={styles.label}>
                  {item === 'park' && 'Park'}
                  {item === 'mall' && 'AVM'}
                  {item === 'metro' && 'Metro'}
                  {item === 'bus' && 'Otobüs'}
                </label>
                <input
                  type="text"
                  placeholder="Mesafe"
                  value={formData.locationInfo.surroundings?.[item]?.distance || ""}
                  onChange={(e) => handleNestedInputChange('locationInfo', 'surroundings', item, {
                    ...formData.locationInfo.surroundings?.[item],
                    distance: e.target.value
                  })}
                  style={styles.input}
                />
                <input
                  type="text"
                  placeholder="İsim"
                  value={formData.locationInfo.surroundings?.[item]?.name || ""}
                  onChange={(e) => handleNestedInputChange('locationInfo', 'surroundings', item, {
                    ...formData.locationInfo.surroundings?.[item],
                    name: e.target.value
                  })}
                  style={styles.input}
                />
              </div>
            ))}
          </div>

          {/* Kurumlar */}
          <h3 style={styles.subSectionTitle}>Kurum ve Kuruluşlar</h3>
          <div style={styles.grid}>
            {['school', 'hospital', 'municipality', 'post_office'].map(item => (
              <div key={item} style={styles.fieldGroup}>
                <label style={styles.label}>
                  {item === 'school' && 'Okul'}
                  {item === 'hospital' && 'Hastane'}
                  {item === 'municipality' && 'Belediye'}
                  {item === 'post_office' && 'Postane'}
                </label>
                <input
                  type="text"
                  placeholder="Mesafe"
                  value={formData.locationInfo.institutions?.[item]?.distance || ""}
                  onChange={(e) => handleNestedInputChange('locationInfo', 'institutions', item, {
                    ...formData.locationInfo.institutions?.[item],
                    distance: e.target.value
                  })}
                  style={styles.input}
                />
                <input
                  type="text"
                  placeholder="İsim"
                  value={formData.locationInfo.institutions?.[item]?.name || ""}
                  onChange={(e) => handleNestedInputChange('locationInfo', 'institutions', item, {
                    ...formData.locationInfo.institutions?.[item],
                    name: e.target.value
                  })}
                  style={styles.input}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Daire Tipleri */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>📐 Daire Tipleri</h2>
            <button 
              onClick={addNewUnit}
              style={styles.addButton}
              type="button"
            >
              + Yeni Daire Tipi Ekle
            </button>
          </div>

          {formData.floorPlans.units?.map((unit, index) => (
            <div key={index} style={styles.unitCard}>
              <div style={styles.unitHeader}>
                <h4 style={styles.unitTitle}>Daire Tipi {index + 1}</h4>
                <button
                  onClick={() => removeUnit(index)}
                  style={styles.deleteUnitButton}
                  type="button"
                >
                  🗑️ Daire Tipini Sil
                </button>
              </div>

              <div style={styles.grid}>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Daire Tipi *</label>
                  <select
                    value={unit.type || ""}
                    onChange={(e) => handleUnitChange(index, 'type', e.target.value)}
                    style={styles.select}
                    required
                  >
                    <option value="">Tip seçin</option>
                    {apartmentTypes.map((type) => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Net Alan (m²) *</label>
                  <input
                    type="number"
                    placeholder="Net Alan"
                    value={unit.net_area || ""}
                    onChange={(e) => handleUnitChange(index, 'net_area', e.target.value)}
                    style={styles.input}
                    required
                  />
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Brüt Alan (m²) *</label>
                  <input
                    type="number"
                    placeholder="Brüt Alan"
                    value={unit.gross_area || ""}
                    onChange={(e) => handleUnitChange(index, 'gross_area', e.target.value)}
                    style={styles.input}
                    required
                  />
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Cephe *</label>
                  <input
                    type="text"
                    placeholder="Cephe"
                    value={unit.facade || ""}
                    onChange={(e) => handleUnitChange(index, 'facade', e.target.value)}
                    style={styles.input}
                    required
                  />
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Balkon *</label>
                  <select
                    value={unit.balcony ? "Var" : "Yok"}
                    onChange={(e) => handleUnitChange(index, 'balcony', e.target.value === "Var")}
                    style={styles.select}
                    required
                  >
                    <option value="Var">Var</option>
                    <option value="Yok">Yok</option>
                  </select>
                </div>
              </div>
              
              {/* Daire Tipi Görseli */}
              <div style={styles.fieldGroup}>
                <label style={styles.label}>Kat Planı Görseli</label>
                {unit.image_url && (
                  <div style={styles.unitImageContainer}>
                    <img src={unit.image_url} alt={`${unit.type} kat planı`} style={styles.unitImage} />
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleUnitImageChange(index, e.target.files[0])}
                  style={styles.fileInput}
                />
                {unitImages[index] && (
                  <div style={styles.newUnitImagePreview}>
                    <p style={styles.newFileInfo}>Yeni görsel: {unitImages[index].name}</p>
                    <img 
                      src={URL.createObjectURL(unitImages[index])} 
                      alt="Yeni kat planı" 
                      style={styles.newUnitImage} 
                    />
                  </div>
                )}
              </div>
            </div>
          ))}

          {(!formData.floorPlans.units || formData.floorPlans.units.length === 0) && (
            <div style={styles.emptyState}>
              <div style={styles.emptyIcon}>📐</div>
              <p style={styles.emptyText}>
                Henüz daire tipi eklenmemiş. İlk daire tipini eklemek için butona tıklayın.
              </p>
            </div>
          )}
        </div>

        {/* Özellikler */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>⭐ Proje Özellikleri</h2>
          
          {/* Bina Özellikleri */}
          <h3 style={styles.subSectionTitle}>🏢 Bina Özellikleri</h3>
          <div style={styles.featuresGrid}>
            {buildingFeaturesList.map(feature => (
              <div key={feature} style={styles.featureItem}>
                <input
                  type="checkbox"
                  id={`building-${feature}`}
                  checked={formData.buildingFeatures[feature] || false}
                  onChange={(e) => handleFeatureChange('buildingFeatures', feature, e.target.checked)}
                  style={styles.checkbox}
                />
                <label htmlFor={`building-${feature}`} style={styles.featureLabel}>
                  {feature}
                </label>
              </div>
            ))}
          </div>

          {/* Dış Özellikler */}
          <h3 style={styles.subSectionTitle}>🌳 Dış Özellikler</h3>
          <div style={styles.featuresGrid}>
            {outsideFeaturesList.map(feature => (
              <div key={feature} style={styles.featureItem}>
                <input
                  type="checkbox"
                  id={`outside-${feature}`}
                  checked={formData.outsideFeatures[feature] || false}
                  onChange={(e) => handleFeatureChange('outsideFeatures', feature, e.target.checked)}
                  style={styles.checkbox}
                />
                <label htmlFor={`outside-${feature}`} style={styles.featureLabel}>
                  {feature}
                </label>
              </div>
            ))}
          </div>

          {/* Çevre Özellikleri */}
          <h3 style={styles.subSectionTitle}>🏙️ Çevre Özellikleri</h3>
          <div style={styles.featuresGrid}>
            {environmentFeaturesList.map(feature => (
              <div key={feature} style={styles.featureItem}>
                <input
                  type="checkbox"
                  id={`environment-${feature}`}
                  checked={formData.environmentFeatures[feature] || false}
                  onChange={(e) => handleFeatureChange('environmentFeatures', feature, e.target.checked)}
                  style={styles.checkbox}
                />
                <label htmlFor={`environment-${feature}`} style={styles.featureLabel}>
                  {feature}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Kaydet Butonu */}
        <div style={styles.buttonContainer}>
          <button 
            onClick={handleSave}
            style={{
              ...styles.saveButton,
              ...((saving || uploading) && styles.saveButtonDisabled)
            }}
            disabled={saving || uploading}
          >
            {saving || uploading ? (
              <>
                <div style={styles.spinner}></div>
                {uploading ? "Dosyalar Yükleniyor..." : "Kaydediliyor..."}
              </>
            ) : (
              "Değişiklikleri Kaydet"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  mainContainer: {
    width: "100%",
    maxWidth: "1200px",
    margin: "60px auto",
    padding: "20px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
    padding: "20px 0",
  },
  mainTitle: {
    fontSize: "2rem",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "1rem",
    color: "#64748b",
    fontWeight: "400",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  section: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e2e8f0",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "15px",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0",
    paddingBottom: "10px",
  },
  subSectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#374151",
    margin: "20px 0 15px 0",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    marginBottom: "20px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontWeight: "600",
    color: "#374151",
    fontSize: "14px",
  },
  input: {
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    outline: "none",
    transition: "all 0.3s ease",
    color: '#374151',
    backgroundColor: '#fff',
  },
  select: {
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    outline: "none",
    transition: "all 0.3s ease",
    color: '#374151',
    backgroundColor: '#fff',
  },
  textarea: {
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "2px solid #e5e7eb",
    resize: "vertical",
    minHeight: "100px",
    outline: "none",
    color: '#374151',
    transition: "all 0.3s ease",
  },
  unitCard: {
    backgroundColor: "#f8fafc",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    marginBottom: "20px",
  },
  unitHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
    flexWrap: "wrap",
    gap: "10px",
  },
  unitTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1e293b",
    margin: "0",
  },
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "10px",
    marginBottom: "20px",
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "8px 12px",
    backgroundColor: "#f8fafc",
    borderRadius: "6px",
    border: "1px solid #e2e8f0",
  },
  checkbox: {
    width: "16px",
    height: "16px",
  },
  featureLabel: {
    fontSize: "14px",
    color: "#374151",
    cursor: "pointer",
  },
  // Görsel stilleri
  imagesContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
    gap: "15px",
    marginTop: "10px",
  },
  imageItem: {
    position: "relative",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "10px",
    backgroundColor: "#fff",
  },
  image: {
    width: "100%",
    height: "120px",
    objectFit: "cover",
    borderRadius: "4px",
  },
  deleteImageButton: {
    width: "100%",
    marginTop: "8px",
    padding: "6px 12px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "12px",
    cursor: "pointer",
  },
  noImagesText: {
    color: "#6b7280",
    fontStyle: "italic",
    textAlign: "center",
    padding: "20px",
  },
  fileInput: {
    width: "100%",
    padding: "10px",
    border: "2px dashed #d1d5db",
    borderRadius: "8px",
    backgroundColor: "#f8fafc",
  },
  newImagesPreview: {
    marginTop: "15px",
    padding: "15px",
    backgroundColor: "#f0f9ff",
    border: "1px solid #0ea5e9",
    borderRadius: "8px",
  },
  newImagesTitle: {
    fontWeight: "600",
    color: "#0369a1",
    marginBottom: "10px",
  },
  newImagesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
    gap: "10px",
  },
  newImageItem: {
    position: "relative",
    border: "1px solid #bae6fd",
    borderRadius: "6px",
    padding: "8px",
    backgroundColor: "#fff",
  },
  newImage: {
    width: "100%",
    height: "80px",
    objectFit: "cover",
    borderRadius: "4px",
  },
  removeNewImageButton: {
    position: "absolute",
    top: "2px",
    right: "2px",
    width: "20px",
    height: "20px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  fileName: {
    fontSize: "10px",
    color: "#64748b",
    marginTop: "4px",
    display: "block",
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  brochureInfo: {
    marginBottom: "10px",
    padding: "10px",
    backgroundColor: "#f0f9ff",
    border: "1px solid #0ea5e9",
    borderRadius: "6px",
  },
  downloadLink: {
    color: "#0369a1",
    textDecoration: "none",
    marginLeft: "8px",
    fontWeight: "600",
  },
  newFileInfo: {
    fontSize: "12px",
    color: "#059669",
    marginTop: "5px",
    fontWeight: "500",
  },
  unitImageContainer: {
    marginBottom: "10px",
  },
  unitImage: {
    maxWidth: "200px",
    maxHeight: "150px",
    borderRadius: "6px",
    border: "1px solid #e2e8f0",
  },
  newUnitImagePreview: {
    marginTop: "10px",
  },
  newUnitImage: {
    maxWidth: "150px",
    maxHeight: "100px",
    borderRadius: "4px",
    border: "1px solid #86efac",
    marginTop: "5px",
  },
  // Buton stilleri
  addButton: {
    padding: "10px 16px",
    backgroundColor: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  deleteUnitButton: {
    padding: "8px 12px",
    backgroundColor: "#ef4444",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  emptyState: {
    textAlign: "center",
    padding: "40px 20px",
    backgroundColor: "#f8fafc",
    borderRadius: "8px",
    border: "1px dashed #d1d5db",
  },
  emptyIcon: {
    fontSize: "32px",
    marginBottom: "12px",
  },
  emptyText: {
    fontSize: "14px",
    color: "#6b7280",
    margin: "0 auto",
    maxWidth: "300px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "40px",
  },
  saveButton: {
    padding: "16px 40px",
    backgroundColor: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    minWidth: "200px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
  },
  saveButtonDisabled: {
    backgroundColor: "#9ca3af",
    cursor: "not-allowed",
  },
  spinner: {
    width: "20px",
    height: "20px",
    border: "2px solid transparent",
    borderTop: "2px solid white",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// Add CSS animation for spinner
const focusStyles = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  input:focus, select:focus, textarea:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
  
  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  button:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  }
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = focusStyles;
document.head.appendChild(styleSheet);